export const VALIDATION_DEBOUNCE_TIME = 500;
